export enum LoginView {
  employee = 'employee',
  branch = 'branch',
}
